import { useEffect } from "react";
import "./index.css";

import Container from "../../../Components/General/Container";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import AOS from "aos";
import "../../../../src/assets/css/aos.css";
import History from "./History";

const CultureSectionMainImg = "https://images.nowpurchase.com/landing/20260424031334_CultureSectionMainImg.png";
function HeroPageCulture() {
  useEffect(() => {
    const aosElements = document.querySelectorAll(".aosAnim");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ltr");
            // entry.target.classList.remove("ltr-out");
          } else {
            // entry.target.classList.add("ltr-out");
            // entry.target.classList.remove("ltr");
          }
        });
      },
      {
        threshold: 0.3,
        // rootMargin: "-10px",
      },
    );

    aosElements.forEach((el) => {
      observer.observe(el);
    });

    // Clean up the observer on component unmount
    return () => {
      aosElements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1200,
    });

    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

    // GSAP Animation
    const main = gsap
      .timeline({
        scrollTrigger: {
          trigger: "#svg",
          scrub: true,
          start: "top-=300 top",
          end: "bottom center",
        },
      })
      .to("#target", {
        duration: 25,
        motionPath: {
          path: "#mainPath",
          align: "#mainPath",
          alignOrigin: [0.6, 0.6],
          autoRotate: true,
        },
      });

    // Cleanup function for useEffect
    return () => {
      main.kill();
    };
  }, []);

  return (
    <div
      className="marketbnr  animated-section section pb-0"
      id="sec41"
      style={{ overflow: "hidden" }}
    >
      <div className="overflowSection1">
        <Container>
          <div className="row bannerContent aosAnim cultur">
            <div className="col-md-8 leftBannerCont">
              <div className="bannerLeft">
                <h2>
                  Diverse people, Different ideas:
                  <br className="desktop-break" /> One platform
                </h2>
                <p>
                  At NowPurchase, we value uniqueness, diversity, and
                  exceptional <br />
                  teamwork. Our philosophy is simple: great things happen when{" "}
                  <br /> people come together to achieve a common goal.
                </p>
                <a
                  href="https://nowpurchase.notion.site/nowpurchase/Join-us-NowPurchase-bb37eb8f73444aef96bfd48b626bbbad"
                  id="Culture_Section1_Landing_SeeJobOpenings"
                  target="_blank"
                  className="npButton joblink"
                >
                  See Job Openings
                </a>
              </div>
            </div>
            <div className="col-md-4 rightBannerImg">
              <div className="bannerRight">
                <div className="bannerPoly cultureImgPoly">
                  <img loading="lazy" src="https://images.nowpurchase.com/landing/20260610045835_Group 889445 (9).png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="historySpacer"></div>
      <History />
    </div>
  );
}

export default HeroPageCulture;
